import axios from 'services/axiosInstance';
import { SORT, DEFAULT_SKIP, LIMIT_ALL } from 'consts/table';

export interface SchoolUnionFile {
   id: string;
   title: string;
   url: string;
   category: string;
   isPublished: boolean;
   createdAt?: string;
}

export interface SchoolUnionFileCategory {
   id: string;
   key: string;
   name: string;
   isPublished: boolean;
   sortOrder: number;
}

export function getAllSchoolUnionFiles(schoolId: string, where: any) {
   const config = {
      params: {
         filter: {
            where: {
               ...where
            },
            skip: DEFAULT_SKIP,
            limit: LIMIT_ALL,
            order: `createdAt ${SORT.DESC}`
         }
      }
   };

   return axios.get(`${window.apiBase}/public/schools/${schoolId}/files`, config)
      .then(response => {
         return response.data;
      });
};

export function getSchoolUnionFileCategories(schoolId: string): Promise<SchoolUnionFileCategory[]> {
   return axios.get(`${window.apiBase}/public/schools/${schoolId}/fileCategories`)
      .then(response => response.data);
}
